<template>
    <base-table-row>
        <!-- <base-table-cell>
            <div v-if="nextActionDue" class="flex h-5 max-w-10 items-center justify-center">
                <input v-model="isSelected" type="checkbox">
            </div>
            <div v-else class="flex h-5 items-center justify-center">
                --
            </div>
        </base-table-cell> -->
        <base-table-cell @click.alt="openClientTasksInEdit" @click.exact="openClientTasks" class="hover:cursor-pointer">
            <div class="whitespace-nowrap flex justify-between [&:not(:hover)]:truncate hover:whitespace-normal w-28">
                {{ clientName }}
            <div v-if="clientLoading" class="w-fit ml-2">
                <PaginationLoader
                    class="rounded-full hover:bg-gray-300"
                    :isLoading="clientLoading"
                    ></PaginationLoader>
            </div>
            </div>
        </base-table-cell>
        <base-table-cell  @click.exact="openClientTasks" @click.alt="openClientTasksInEdit" class="hover:cursor-pointer">
            <div class="whitespace-nowrap [&:not(:hover)]:truncate hover:whitespace-normal">
                {{ coverageName }}
            </div>
        </base-table-cell>
        <base-table-cell @click.alt="openClientTasksInEdit" @click.exact="openClientTasks" class="hover:cursor-pointer">
            <NextTaskDueCell :next-step="nextTaskDue" />
        </base-table-cell>
        <base-table-cell @click.alt="openClientTasksInEdit" @click.exact="openClientTasks" class="hover:cursor-pointer">
            <div>
                {{ nextTaskDate }}
            </div>
        </base-table-cell>
        <base-table-cell @click.alt="openClientTasksInEdit" @click.exact="openClientTasks" class="hover:cursor-pointer">
           <NextTaskDetailsCell :next-step="nextTaskDue" />
        </base-table-cell>
        <base-table-cell @click.alt="openClientTasksInEdit" @click.exact="openClientTasks" class="hover:cursor-pointer">
            <NextTaskResponsibleCell :next-step="nextTaskDue" />
        </base-table-cell>
        <base-modal :is-form-visible="clientTasksVisible" @close="closeClientTasks">
            <template #header>
            <h2 class="text-lg">
                {{ clientName }} Tasks
            </h2>
            </template>
            <template #body>
            <ClientTasksPage class="text-[0.8rem]" :client="client" :client-task-types="clientTaskTypes" @close="closeClientTasks" :open-in-edit="openInEdit" @refetch-clients="fetchNewClients" @save-and-close="bulkUpdateClientTasks" />
            </template>
        </base-modal>
    </base-table-row>
</template>

<script setup>
import { defineProps, defineEmits, computed, ref, watch } from 'vue';
import ClientTasksPage from './ClientTasksPage.vue';
import NextTaskDetailsCell from './NextTaskDetailsCell.vue';
import NextTaskDueCell from './NextTaskDueCell.vue';
import NextTaskResponsibleCell from './NextTaskResponsibleCell.vue';
import { getTodaysDateAsString } from '@/composables/formatDate';
import { useToast } from 'vue-toast-notification';
import { updateClientTasks } from '@/services/Client';
import { useStore } from 'vuex';
import PaginationLoader from '../base-components/PaginationLoader.vue';
import { formatDateTwoDigitYear } from '@/composables/formatDate';

const store = useStore()
const $toast = useToast()
const emit = defineEmits([
    'refetch-clients'
])

const props = defineProps([
    'client', 'clientTaskTypes', 'userOptions', 'selected-tasks'
])

const clientLoading = ref(false)
const waitingForMoreChanges = ref(false)
const openInEdit = ref(false)

// watch(() => props.selectedDetails, () => {
//     if(nextActionDue.value){
//         if(props.selectedDetails.find((id) => id == nextActionDue.value.id)){
//             isSelected.value = true
//         } else {
//             isSelected.value = false
//         }
//     }
// })

function setClientLoading(trueOrFalse){
    clientLoading.value = trueOrFalse
}

const isSelected = ref(false)

// watch(isSelected, () => {
//     if(isSelected.value){
//         emit('add-selected-detail', nextActionDue.value.id)
//     } else {
//         emit('remove-selected-detail', nextActionDue.value.id)
//     }
// })

const client = ref(props.client)

const changeCount = ref(0)

function setClient(clientData){
    client.value = clientData
    // setClientLoading(false)
}

watch(props, () => {
    if(props.client) {
        client.value = props.client
    }
})

const clientTasksVisible = ref(false)

const clientName = computed(() => {
    if(client.value){
        return client.value.client_name
    } else {
        return  '--'
    }
})

const coverageName = computed(() => {
    if(client.value){
        const manager = client.value.active_account_manager
        if(manager && manager.user){
            return `${manager.user.first_name} ${manager.user.last_name}` 
        } else {
            return '--'
        }
    } else {
        return  '--'
    }
})

function openClientTasks(){
    clientTasksVisible.value = true
}

function openClientTasksInEdit(){
    openInEdit.value = true
    clientTasksVisible.value = true
}

function closeClientTasks(){
    clientTasksVisible.value = false
    openInEdit.value = false
}

function sortByDueDate(a, b){
    if(a.due_date && b.due_date){
        if(a.due_date == b.due_date){
            return parseFloat(a.ordinal) - parseFloat(b.ordinal) || new Date(a.created_at) - new Date(b.created_at)
        } else {
            return new Date(a.due_date) - new Date(b.due_date)
        }
    } else if ((a.due_date && !b.due_date)){
        return 1
    } else if ((b.due_date && !a.due_date)){
        return -1
    } else {
        return parseFloat(a.ordinal) - parseFloat(b.ordinal) || new Date(a.created_at) - new Date(b.created_at)
    }
}

const nextTaskDue = computed(() => {
    if(client.value.tasks.length > 0){
        let openTasks = client.value.tasks.filter((task) => {
            return !task.resolved_date
        })
        if(openTasks.length > 0){
            openTasks = openTasks.sort(sortByDueDate)
            return openTasks[0]
        } else {
            return null
        }
    } else {
        return null
    }
})

const nextTaskDate = computed(() => {
    if(nextTaskDue.value){
        return formatDateTwoDigitYear(nextTaskDue.value.due_date)
    } else {
        return '--'
    }
})

function fetchNewClients(){
    emit('refetch-clients')
}

  async function bulkUpdateClientTasks(clientTasks) {
      clientLoading.value = true 
      changeCount.value += 1
      let taskRows = clientTasks
      if(taskRows) {
        client.value.tasks = taskRows
        const payload = {
            token: store.state.auth.token,
            formData: JSON.stringify(
            {
                client_tasks: taskRows
            }),
            clientId: props.client.id
        }
        clientTasksVisible.value = false
        openInEdit.value = false
        const response = await updateClientTasks(payload)
        if(response.status == 200) {
            changeCount.value -= 1
            if(changeCount.value < 1){
                $toast.open({
                    message: `Successfully Updated Tasks for ${client.value.client_name}.`,
                    type: 'success',
                    duration: 5000
                })
                setClient(response.data.client)
                clientLoading.value = false
            }
        } else {
            $toast.open({
                message: `Unable to Update Tasks for ${client.value.client_name}`,
                type: 'error',
                duration: 20000
            })
        }
      } else {
          clientLoading.value = false
      }
  
  }




</script>